import { useCallback } from 'react';

export const useURLSearchParams = () => {
  const getSearchParam = useCallback((): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get('search');
  }, []);

  const setSearchParam = useCallback((value: string) => {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set('search', value);
    } else {
      url.searchParams.delete('search');
    }
    window.history.replaceState({}, '', url.toString());
  }, []);

  const clearSearchParam = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('search');
    window.history.replaceState({}, '', url.toString());
  }, []);

  return {
    getSearchParam,
    setSearchParam,
    clearSearchParam,
  };
};
